import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Registration Levels',
  basePath: '/reg-levels',
  columns: [
    { key: 'level', label: 'Level', sortable: true },
    { key: 'reg_from', label: 'From', sortable: true },
    { key: 'reg_to', label: 'To', sortable: true },
    { key: 'description', label: 'Description', sortable: true },
  ],
  fields: [
    { key: 'level', label: 'Level', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'reg_from', label: 'From', type: 'text' },
    { key: 'reg_to', label: 'To', type: 'text' },
  ],
  defaultSort: { field: 'level', dir: 'asc' },
});
